import { useSelector, useDispatch } from "react-redux";
import TelegramView from "../components/TelegramView";
import { Routes, Route } from "react-router-dom";
import Game from "../components/Game";
import Dashbord from "../components/Dashbord";
import Dialog from "../components/Dialog";
import SideMenu from "../components/SideMenu";
import Rules from "../components/Rules";
import Profile from "../components/Profile";
import Instruction from "../components/Instruction";
import Price from "../components/Price";
import SubscriptionAlertBanner from "../components/SubscriptionAlertBanner";
import KnowledgeBasePage from "./KnowledgeBasePage";
import { useEffect } from "react";
import {
  getRules,
  getInfo,
  getInstruction,
} from "../redux/asyncThunk/serviceActions";
import { getProfile } from "../redux/asyncThunk/userActions";
import { userSlice } from "../redux/user/userSlice";
import "./app-workspace.css";

const { clearMessages } = userSlice;

export default function PersonalPage() {
  const dispatch = useDispatch();

  const showDialog = useSelector((state) => state.user.showDialog);
  const rules = useSelector((state) => state.serviceData.rules);
  const info = useSelector((state) => state.serviceData.info);
  const userId = useSelector((state) => state.user.data?.user?.id);
  const profile = useSelector((state) => state.user?.profile);
  const userBusinessSubscription = useSelector(
    (state) => state.user?.data?.user?.businessSubscription,
  );
  const businessSubscription =
    profile?.businessSubscription ?? userBusinessSubscription ?? null;

  useEffect(() => {
    if (!rules.lenght || !info.lenght) {
      dispatch(getRules());
      dispatch(getInfo());
      dispatch(getInstruction());
    }
    dispatch(clearMessages());
  }, [dispatch, info.lenght, rules.lenght, userId]);

  useEffect(() => {
    if (userId) {
      dispatch(getProfile({ id: userId }));
    }
  }, [dispatch, userId]);

  return (
    <div className="app-workspace">
      <SideMenu />

      <div className="app-workspace__main">
        <SubscriptionAlertBanner
          businessSubscription={businessSubscription}
          storage={profile?.storage ?? null}
          teamUsage={profile?.teamUsage ?? null}
        />
        <Routes>
          <Route path="/" element={<Dashbord />} />
          <Route
            path="/knowledge-base"
            element={
              <div className="app-main app-main--knowledge-base">
                <KnowledgeBasePage />
              </div>
            }
          />
          <Route
            path="/:id"
            element={
              <div className="app-main">
                <Game />
              </div>
            }
          />
          <Route
            path="/profile"
            element={
              <div className="app-main">
                <Profile />
              </div>
            }
          />
          <Route
            path="/rules"
            element={
              <div className="app-main">
                <Rules />
              </div>
            }
          />
          <Route
            path="/instruction"
            element={
              <div className="app-main">
                <Instruction />
              </div>
            }
          />
          <Route
            path="/price"
            element={
              <div className="app-main">
                <Price />
              </div>
            }
          />
        </Routes>
      </div>

      <TelegramView />

      {showDialog.isOpen ? <Dialog /> : null}
    </div>
  );
}
